import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from './accordion/accordion.component';
import { GridModule } from '@tmhcc-ng-lib/framwork/grid';
@NgModule({
  declarations: [AccordionComponent],
  imports: [CommonModule, GridModule],
  exports: [AccordionComponent]
})
export class AccordionControlModule {}
